function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5 0.0163574C2.23858 0.0163574 0 2.25493 0 5.01636V30.5164H24L24 0.0163574H5Z",
  fill: "#18A43B"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M26 0.0163574L26 30.5164H48V5.01636C48 2.25493 45.7614 0.0163574 43 0.0163574H26Z",
  fill: "#18A43B"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M48 32.5164H34V48.0164H43C45.7614 48.0164 48 45.7778 48 43.0164V32.5164Z",
  fill: "#18A43B"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M32 48.0164V32.5164H17V48.0164H32Z",
  fill: "#18A43B"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M15 48.0164V32.5164H0V43.0164C0 45.7778 2.23858 48.0164 5 48.0164H15Z",
  fill: "#18A43B"
});

var Svg5AActive = function Svg5AActive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg5AActive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/5a_active.3df8ae81.svg";
export { ForwardRef as ReactComponent };